"use client";

import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { memo } from "react";
import { ChevronLeft, ChevronRight, MoveUpRight } from "lucide-react";
import { useSelector } from "react-redux";
import { useRouter, usePathname } from "next/navigation";

interface SuggestedActionsProps {
  onSelect: (prompt: string) => void;
  chatType?: "chat";
  dynamicPrompts?: string[];
}
function PureSuggestedActions({
  onSelect,
  dynamicPrompts = [],
}: SuggestedActionsProps) {
  const pathname = usePathname();
  const { activeTab } = useSelector((state) => state.main);
  const isProjectPage = pathname.startsWith("/project");
  const effectiveTab = activeTab ?? "Page Builder";
  const suggestedCardActions = [
    {
      title: "Birthday Card",
      action:
        "Design an elegant birthday greeting card featuring soft golden sparkles, luxurious deep red and ivory tones, delicate floral elements, and a central area for custom text. Include a gold-foil effect 'Happy Birthday Sam' heading in a stylish calligraphy font. The layout should include space for a name, message. The design should be minimal yet festive, suitable for both adults and kids. Background should be softly textured (like watercolor or fine paper). Format in portrait orientation. Include birthday cake or balloon icon subtly in one corner. Transparent background.",
    },
    {
      title: "Wedding Invitation Card",
      action:
        "Create an elegant wedding invitation card. Sections: Couple names, Event date & venue. Minimal and classy design with soft pastels.",
    },
    // {
    //   title: "Thank You Card",
    //   action:
    //     "Make a professional thank you card. Sections: Greeting, personalized message, signature, optional illustration. Use clean typography and subtle accent colors.",
    // },
    // {
    //   title: "Event Invitation Card",
    //   action:
    //     "Create a vibrant invitation card for a conference. Include event title, date/time, speakers. Style it with bold, modern fonts and a clean layout.",
    // },
    // {
    //   title: "Holiday Greeting Card",
    //   action:
    //     "Create a festive Diwali greeting card for October 21, 2025. Sections: Holiday-themed hero image (like diyas, lights, rangoli), a warm Diwali greeting message, and decorative illustrations. Use bright, cheerful colors and elegant, festive fonts. Include a short heartfelt message wishing happiness and prosperity for Diwali.",
    // },
    {
      title: "Baby Shower Card",
      action:
        "Design a cute baby shower card. Sections: Baby name, event details, playful illustrations. Soft pastel colors with whimsical fonts for a joyful feel.",
    },
    {
      title: "Congratulations Card",
      action:
        "Generate a congratulations card. Sections: Hero with congratulatory message, personalized text, optional illustration. Elegant design with celebratory colors.",
    },
    {
      title: "Get Well Soon Card",
      action: `Make a caring get well soon card. Sections: Hero with message, personalized note, optional flowers/illustration. Soft and soothing color palette. Use gentle typography to convey warmth and comfort.
        
        `,
    },
  ];

  const suggestedWebsiteActions = [
    {
      // title: "Software Developer Resume Portfolio",
      title: "Resume Portfolio",
      action:
        "Create a  portfolio (dark premium). Sections: Hero with gradient name, Selected Projects grid (cards open detail), Services, Tech stack pills, Testimonials, Contact. Emphasize visuals and clean spacing.",
    },
    // {
    //   // title: "Agency and SaaS Business Marketing",
    //   title: "Business Marketing",
    //   action: `Design a  SaaS/Agency page. Sections: Sticky navbar, Hero with product preview, Feature grid (6), Integrations strip, Pricing (3 tiers), Logos, Testimonials, FAQ, CTA, Footer. Use ring-1 ring-white/10 on buttons, no glass effects`,
    // },
    {
      // title: "Doctor & Clinic Trust-Building Hub",
      title: "Doctor & Clinic Hub",
      action: `Make a  clinic website. Sections: Hero with specialties, Services grid, Doctor bio cards, Appointment form, Insurance/affiliations strip, Patient reviews, Location/Hours, Contact. Clean, trustworthy, dark premium styling.`,
    },
    // {
    //   // title: "Event, Planning & Management",
    //   title: "Planning & Management",
    //   action:
    //     "Generate a  conference page. Sections: Hero with dates/CTA, Speaker grid, Agenda preview, Venue & travel, Sponsors grid, Tickets/pricing, FAQ, Footer. Premium, legible typography, subtle hover states",
    // },
    // {
    //   // title: "Online CV & Professional Resume",
    //   title: "Professional Resume ",
    //   action:
    //     "Create a premium  single-page CV/Resume site. Dark theme #0B0F17. Sections: Hero (name, title, CTA), Skills, Experience timeline, Projects, Education, Testimonials, Contact. Use subtle borders border-white/10, cards with bg-white/[0.02], no glassmorphism.",
    // },
    {
      // title: "Restaurant and Café Food Business",
      title: "Restaurant and Café",
      action: `Build a  site for a Café/Restaurant. Sections: Hero with signature dish, About, Menu grid, Gallery strip, Reviews, Reservation form, Map/footer. Dark premium palette with warm accent.`,
    },
    {
      // title: "Wedding & Invitation Microsite",
      title: "Wedding & Invitations",
      action: `Create an elegant  wedding/invitation microsite. Sections: Hero names & date, Story timeline, Event schedule, Venue card with map link, Gallery, RSVP form. Minimal, refined, subtle borders`,
    },
    {
      // title: "Fitness Coach and Personal Training",
      title: "Fitness Training",
      action:
        "Build a  landing page for a Fitness Coach/Gym. Dark elegant style. Sections: Hero with transformation images, Program cards (Beginner/Pro/Personal), Benefits grid, Trainer bio, Schedule teaser, Pricing, FAQ, Contact. Use accent indigo & emerald, subtle motion on hover.x",
    },
  ];

  const suggestedBPlanActions = [
    {
      title: "Startup Business Plan",
      action:
        "Create a detailed business plan for a new startup named Tech World that operates in the IT Industory sector. Include sections for: Executive Summary, Company Overview, Market Analysis, Products/Services, Target Audience, Marketing Plan, Operational Plan, Financial Projections, and Future Goals.",
    },
    {
      title: "E-Commerce Business Plan",
      action: `Generate a complete business plan for an e-commerce company selling fashion.The plan should include: business objectives, target audience, online marketing strategies, logistics, fulfillment process, competitive analysis, and projected growth.`,
    },
    {
      title: "SaaS Business Plan",
      action: `Write a professional business plan for a SaaS startup providing.
Include: problem statement, solution, target market, pricing model, user acquisition strategy, competitive advantage, and 3-year financial forecast.`,
    },
    {
      title: "Restaurant Business Plan",
      action:
        "Develop a business plan for a restaurant. Cover: brand identity, menu concept, location strategy, target market, marketing plan, staffing, budget, and financial projections.",
    },
    {
      title: "Fitness/Gym Business Plan",
      action:
        "Create a business plan for a fitness center or gym offering services like personal training, group classes, etc.. Include: business overview, customer demographics, membership structure, marketing plan, equipment investment, and operational strategy.",
    },
    {
      title: "Mobile App Startup Plan",
      action:
        "Write a detailed business plan for a startup called Mobile App Startup Plan. Include sections for Executive Summary, Market Analysis, Product Overview, Marketing Strategy, Operations Plan, and Financial Projections.",
    },
  ];
  console.log(dynamicPrompts, "--dynamicPromptsdynamicPrompts");
  const actionsMap: Record<string, any[]> = {
    "Page Builder": suggestedWebsiteActions,
    "Card Maker": suggestedCardActions,
    "Business Plan": suggestedBPlanActions,
  };
  // const actionsToShow = actionsMap[effectiveTab] || [];
  const defaultActions = actionsMap[effectiveTab] || [];
  const hasDynamicPrompts = dynamicPrompts?.length > 0;
 const actionsToShow =
  dynamicPrompts?.length > 0
    ? dynamicPrompts
    : defaultActions;
  if (!actionsToShow.length) {
    return null;
  }

  return (
    <div className="w-full mt-6">
      <div className="flex flex-col gap-4">
        {actionsToShow.map((item, index) => (
          <div
            key={`suggested-${index}`}
            onClick={() => onSelect(item.action)}
            className="flex items-start justify-between gap-2 cursor-pointer group py-2"
          >
            <div className="flex flex-col min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="text-sm font-semibold dark:text-gray-400 text-black">
                  {item.title}
                </h3>
                <MoveUpRight
                  size={14}
                  className="text-gray-500 shrink-0 group-hover:text-white transition-colors duration-200"
                />
              </div>

              <p className="text-sm text-gray-500 truncate mt-1">
                {item.action}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export const SuggestedActions = memo(
  PureSuggestedActions,
  (prevProps, nextProps) => {
    return (
      prevProps.onSelect === nextProps.onSelect &&
      prevProps.dynamicPrompts === nextProps.dynamicPrompts
    );
  },
);
